module.exports = __webpack_public_path__ + "static/media/SBAC Logo.644438c8.png";